<script lang="ts">
import { gsap } from 'gsap';
import { ref, onMounted, onUnmounted } from 'vue';
import '@sg-core/src/View/Components/Atoms/VisuallyHidden/visually-hidden.css';

interface Emits {
  close: [id?: string | number];
}

export interface ToastProps {
  closeText: string;
  text: string;
  type?: 'info' | 'warning' | 'danger' | 'success';
  duration?: number;
  persistant?: boolean;
  id?: string | number;
}
</script>

<script setup lang="ts">
const { closeText, text, type = 'info', duration = 8000, persistant, id } = defineProps<ToastProps>();

const emit = defineEmits<Emits>();

const toastRef = ref<HTMLLIElement | null>(null);
let ctxGsap: gsap.Context | null = null;

const handleClose = (): void => {
  emit('close', id);
};

onMounted(() => {
  if (!toastRef.value || persistant) {
    return;
  }

  ctxGsap = gsap.context(() => {
    gsap.timeline({
      onComplete: () => emit('close', id),
      duration: duration / 1000,
    });
  }, toastRef.value);
});

onUnmounted(() => {
  if (ctxGsap) {
    ctxGsap.kill();
  }
});

defineExpose({ toastRef });
</script>

<template>
  <li ref="toastRef" class="phxsg-toaster__item" role="presentation">
    <div :class="['phxsg-toast', `phxsg-toast--${type}`]" role="alert">
      <div class="phxsg-toast__wrapper">
        <div class="phxsg-toast__message">
          {{ text }}
        </div>

        <button class="phxsg-toast__close" @click="handleClose">
          <span class="phxsg-visually-hidden">{{ closeText }}</span>
        </button>
      </div>
    </div>
  </li>
</template>
